import { useQuery } from 'react-query';
import type { UserRepository } from 'services/repositories/interfaces/UserRepository';
import { QueryKeys } from 'utils/queryKeys';

export const useCurrentUserQuery = (userRepository: UserRepository, { enabled }: { enabled: boolean }) => {
  return useQuery({ queryKey: QueryKeys.currentUser, queryFn: () => userRepository.getUserMe(), staleTime: 300, enabled });
};
